/* Primal Viking — Footer (language selector popover) */

(function () {
  var ROOT_SELECTOR = '[data-footer-language]';
  var COOKIE = 'lang_preference_set';
  var COOKIE_MAX_AGE = 31536000; /* 365 days */

  function getToggle(root) {
    return root.querySelector('.footer__language-toggle');
  }

  function getList(root) {
    return root.querySelector('.footer__language-list');
  }

  function setOpen(root, open) {
    var toggle = getToggle(root);
    var list = getList(root);
    if (!toggle || !list) return;

    list.hidden = !open;
    root.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init(root) {
    if (root.dataset.languageReady === 'true') return;

    var toggle = getToggle(root);
    var list = getList(root);
    if (!toggle || !list) return;

    root.dataset.languageReady = 'true';

    /* No stopPropagation here: the document handler below already ignores clicks
       inside this root, and swallowing the event would hide every toggle click from
       delegated document-level listeners — Converge/Dashfi and Klaviyo tracking, and
       Focal's own close-on-outside-click in theme.js. */
    toggle.addEventListener('click', function () {
      setOpen(root, list.hidden);
    });

    /* Close when focus leaves the widget entirely, so a keyboard user tabbing past
       the last option does not leave the panel floating over the footer.
       The relatedTarget null-check is load-bearing: focusout fires on mousedown,
       before click, and Node.contains(null) is false. Without it, clicking the
       panel's own padding would close it on a 2px mis-aim — and worse, in Safari
       and Firefox on macOS clicking a link does not focus it, so a keyboard-opened
       panel would close before the option's click ever landed and the language
       would silently fail to switch. A null relatedTarget is always a mouse blur,
       already covered by the document outside-click handler; Tab-out always
       supplies a non-null one, so nothing this handler exists for is lost. */
    root.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !root.contains(event.relatedTarget)) setOpen(root, false);
    });

    list.addEventListener('click', function (event) {
      var link = event.target.closest('.footer__language-option');
      if (!link) return;

      /* Never navigate the Theme Editor away, and never write cookies inside it. */
      if (window.Shopify && window.Shopify.designMode) {
        event.preventDefault();
        return;
      }

      /* The link's href does the navigating; this only records the preference.
         The head script's Rule 2 re-syncs it if this write is ever missed. */
      document.cookie =
        COOKIE +
        '=' +
        encodeURIComponent(link.getAttribute('data-locale')) +
        '; max-age=' +
        COOKIE_MAX_AGE +
        '; path=/; SameSite=Lax';
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), init);
  }

  /* Document-level listeners bind once, and read the live DOM, so Theme Editor
     section re-renders never leave stale closures behind. */
  if (!window.pvFooterLanguageBound) {
    window.pvFooterLanguageBound = true;

    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
        if (!root.contains(event.target)) setOpen(root, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
        var list = getList(root);
        var toggle = getToggle(root);
        if (list && !list.hidden) {
          /* Only pull focus back if it was inside the widget — otherwise Escape
             pressed elsewhere on the page would yank the user down to the footer. */
          var hadFocus = root.contains(document.activeElement);
          setOpen(root, false);
          if (hadFocus && toggle) toggle.focus();
        }
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
